// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page and General Styling */
.page {
  font-family: "Poppins", Arial, sans-serif;
  margin: 0;
  padding: 0;
  position: relative;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.container {
  margin: auto;
  padding: 20px;
  position: relative;
  max-width: 1200px;
}

/* Header */
.header {
  position: relative;
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: #007bff;
}

/* Buttons */
.button {
  background: linear-gradient(90deg, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  transition: transform 0.2s, box-shadow 0.3s;
}

.button:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

/* Cancel Button */
.cancel {
  background: linear-gradient(90deg, #6c757d, #5a6268);
  margin-top: 10px;
}

.cancel:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

/* Table */
.table {
  width: 100px!important;
  border-collapse: collapse;
  margin-top: 20px;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
  font-size: 14px;
}

.table th {
  background-color: #e9ecef;
  color: #495057;
  font-weight: 600;
}

.table tr:nth-child(even) {
  background-color: #f8f9fa;
}

/* Form Popup */
.form-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 15px;
  z-index: 1000;
  width: 90%;
  max-width: 500px;
}

.form {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  margin-bottom: 5px;
  color: #495057;
  font-weight: 500;
}

.input,
.textarea,
select {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 14px;
}

.textarea {
  resize: vertical;
  height: 80px;
}

.error {
  color: #dc3545;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
}

/* Loader */
.loader {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 5px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .button {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RawFruit.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* Page and General Styling */\n.page {\n  font-family: \"Poppins\", Arial, sans-serif;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  min-height: 100vh;\n  background-color: #f8f9fa;\n}\n\n.container {\n  margin: auto;\n  padding: 20px;\n  position: relative;\n  max-width: 1200px;\n}\n\n/* Header */\n.header {\n  position: relative;\n  height: 50px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #007bff;\n}\n\n/* Buttons */\n.button {\n  background: linear-gradient(90deg, #007bff, #0056b3);\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  cursor: pointer;\n  border-radius: 25px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: transform 0.2s, box-shadow 0.3s;\n}\n\n.button:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n/* Cancel Button */\n.cancel {\n  background: linear-gradient(90deg, #6c757d, #5a6268);\n  margin-top: 10px;\n}\n\n.cancel:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n/* Table */\n.table {\n  width: 100px!important;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ddd;\n  padding: 12px;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #e9ecef;\n  color: #495057;\n  font-weight: 600;\n}\n\n.table tr:nth-child(even) {\n  background-color: #f8f9fa;\n}\n\n/* Form Popup */\n.form-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  border-radius: 15px;\n  z-index: 1000;\n  width: 90%;\n  max-width: 500px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  font-size: 14px;\n  margin-bottom: 5px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.input,\n.textarea,\nselect {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.textarea {\n  resize: vertical;\n  height: 80px;\n}\n\n.error {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: -10px;\n  margin-bottom: 10px;\n}\n\n/* Loader */\n.loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .button {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
